module.exports = __webpack_public_path__ + "static/scale-model-of-sky-island-alliance-in-tucson-arizona-25ea069298d5f2a6a24b41d079a5edcd.png";